
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/Articles/ArticleItem",
      function () {
        return require("private-next-pages/components/Articles/ArticleItem/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/Articles/ArticleItem"])
      });
    }
  